module.exports = __webpack_public_path__ + "static/media/save.76390968.svg";